import {slideUp, slideDown} from "es6-slide-up-down";
import {closest} from "glightbox/src/js/utils/helpers";

export default () => {

    const handleClick = (e) => {
        e.preventDefault();
        if (e.target.classList.contains('faq__title-image')) {
            return false;
        }

        const title = e.target;
        const item = closest(title, '[data-acc-item]');
        //title.parentNode.parentNode;
        const content = item.querySelector('[data-accordion-content]');
        if (item.classList.contains('active')) { // close this
            slideUp(content);
            item.classList.remove('active');
        } else {
            slideDown(content);
            item.classList.add('active');
        }
        return false;
    }

    const accordions = document.querySelectorAll('[data-accordion]');
    for (const accordion of accordions) {
        const titles = accordion.querySelectorAll('[data-accordion-title]');
        for (const title of titles) {
            if (!title.getAttribute('data-e')) {
                title.setAttribute('data-e', 1);
                title.addEventListener('click', handleClick);
            }
            // title.removeEventListener('click', handleClick);

        }
    }

}
